import { PaginationSetting } from 'constants/paginationSetting';
import { ProductType } from 'constants/productType';
import { useState } from 'react';
import {
  useGetDomesticRealEstatePositionListQuery,
  useGetOverseasRealEstatePositionListQuery,
  useGetPositionListQuery,
} from 'views/utils/graphql/graphql';
import { HoldingPeriod } from '../symbol/module/fullInfo';

export const usePositionListPage = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [positionList, _] = useGetPositionListQuery({
    variables: {
      count: PaginationSetting.pageCount,
      page: currentPage,
    },
    requestPolicy: 'network-only',
  });

  return {
    positionList,
    currentPage,
    setCurrentPage,
    perPageCount: PaginationSetting.pageCount,
  };
};

export const useDomesticRealEstatePositionListPage = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [positionList, _] = useGetDomesticRealEstatePositionListQuery({
    variables: {
      count: PaginationSetting.pageCount,
      page: currentPage,
    },
    requestPolicy: 'network-only',
  });

  return {
    positionList,
    currentPage,
    setCurrentPage,
    perPageCount: PaginationSetting.pageCount,
  };
};

export const useOverseasRealEstatePositionListPage = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [positionList, _] = useGetOverseasRealEstatePositionListQuery({
    variables: {
      count: PaginationSetting.pageCount,
      page: currentPage,
    },
    requestPolicy: 'network-only',
  });

  return {
    positionList,
    currentPage,
    setCurrentPage,
    perPageCount: PaginationSetting.pageCount,
  };
};
